export const continueBtnDataSet = { cy: 'AIReady-continue-btn' };
